import { ItemElement } from './common.types';
import { TechnologyItem } from './project.types';
//---------------------------------
//-------------ENUMS---------------
//---------------------------------
export enum DocumentName {
  BACHELORS_COMPUTER_SCIENCE = 'Bachelors Computer Science Diploma',
  GDPR = 'Gdpr Certification',
  CIBERSAFE_CITIZEN = 'Cyber Safety Certification',
  JIRA_FUNDAMENTALS = 'Jira Fundamentals Certification',
  CONFLUENCE_FUNDAMENTALS = 'Confluence Fundamentals Certification',
  RESPONSIVE_WEBDESIGN = 'Responsive WebDesign Certification',
  JAVASCRIPT_ALGORITHMS_AND_DATA_STRUCTURES = 'JavaScript Algorithms And Data Structures Certification',
  UNDERSTANDING_TYPESCRIPT = 'Understanding Typescript Certification',
  FRONTEND_DEVELOPER = 'FrontEnd Developer Certification',
  LEARNING_NEXTJS = 'Learning NextJs Certification',
}

export enum Institution {
  ATLASSIAN = 'atlassian',
  NAU = 'nau',
  FREECODECAMP = 'freecodecamp',
  UDEMY = 'udemy',
  LINKEDIN = 'linkedin',
  HACKERRANK = 'hackerrank',
  FCT = 'fct',
}

export enum CredentialType {
  DEGREE = 'degree',
  CERTIFICATION = 'certification',
  LICENSE = 'license',
}

//---------------------------------
//------------TYPES----------------
//---------------------------------

export type DocumentItem = ItemElement & {
  name: DocumentName;
};

export type InstitutionItem = ItemElement & {
  name: Institution;
};

export type CredentialItem = {
  name: string;
  institution: InstitutionItem;
  type: CredentialType;
  startDate?: string;
  endDate: string;
  skills?: string[];
  technologies?: TechnologyItem[];
  document?: DocumentItem | undefined;
};

